import { createAction } from 'redux-actions-helpers'
import { ContestType } from '../ProfileContestsPage/types'
import { MetaWorksType } from './types'
import { MyWorkType } from '../ProfileContestsWorkPage/types'

export const fetchContest = createAction(
  '@@profile-contests-works-list/FETCH_CONTEST',
  (id: string): any => ({ id })
)

export const fetchContestSuccess = createAction(
  '@@profile-contests-works-list/FETCH_CONTEST_SUCCESS',
  (result: ContestType | null): any => ({ result })
)

export const fetchContestFailure = createAction(
  '@@profile-contests-works-list/FETCH_CONTEST_FAILURE',
  (error: string): any => ({ error })
)

export const fetchWorks = createAction(
  '@@profile-contests-works-list/FETCH_WORKS',
  (contest_id: string, search: string, size: number, page: number): any => ({
    contest_id,
    search,
    size,
    page,
  })
)

export const fetchWorksSuccess = createAction(
  '@@profile-contests-works-list/FETCH_WORKS_SUCCESS',
  (result: MyWorkType[], meta: MetaWorksType): any => ({ result, meta })
)

export const fetchWorksFailure = createAction(
  '@@profile-contests-works-list/FETCH_WORKS_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@profile-contests-works-list/DESTROY')
